// extracted by mini-css-extract-plugin
module.exports = {"main":"OutputSettingContainer_main__dHf7N"};